import { format, parse } from "date-fns";
import { date, number, object } from "yup";
import { getNearestTimeElement } from "duck";
import { AnestheticGas, FluidTemperature, Vital } from "requests";

export const getValidation = () => {
  const nullableNumber = number()
    .nullable()
    .default(null)
    .transform(value => (Number.isNaN(value) ? 0 : value));

  const validationSchema = object({
    timeMonitoring: date()
      .required()
      .default(null)
      .nullable(),
    fluidRate: nullableNumber,
    volumeToBeInfused: nullableNumber,
    temperature: nullableNumber,
    oxygen: nullableNumber,
    inhalantAnestheticAgent: nullableNumber,
    heartRate: nullableNumber,
    respiratoryRate: nullableNumber,
    pulseOximetry: nullableNumber,
    endTidal: nullableNumber,
    systolicBloodPressure: nullableNumber,
    meanBloodPressure: nullableNumber,
    diastolicBloodPressure: nullableNumber
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};

export const generateDefaultValues = (
  gases: AnestheticGas[],
  vitals: Vital[],
  fluidTemperatures: FluidTemperature[],
  caseCreationDate: Date
) => {
  const defaultGases = getNearestTimeElement(gases, new Date());
  const defaultVitals = getNearestTimeElement(vitals, new Date());
  const defaultFluids = getNearestTimeElement(fluidTemperatures, new Date());
  const timeMonitoring = `${parse(
    format(new Date(), "h:mm a"),
    "h:mm a",
    caseCreationDate
  )}`;

  return {
    ...(defaultGases ? { ...defaultGases } : {}),
    ...(defaultVitals ? { ...defaultVitals } : {}),
    ...(defaultFluids ? { ...defaultFluids } : {}),
    timeMonitoring
  };
};
